import { computeBuffer } from '../tools/compute-buffer';
import { render } from '../tools/render';
import { resolvePlace } from '../tools/resolve-place';
import { viewZoomTo } from '../tools/view-zoom-to';
import type { Tool } from '../tools/types';

type Input = { text: string; radius_meters: number };

export const bufferAroundPlace: Tool<Input> = {
  name: 'buffer_around_place',
  description:
    'Convenience: resolve_place → compute_buffer → render(buffer) → view.zoom_to. Use for "draw a 5 km circle around Masjid al-Haram" style prompts.',
  input_schema: {
    type: 'object',
    properties: {
      text: { type: 'string' },
      radius_meters: { type: 'number', exclusiveMinimum: 0 },
    },
    required: ['text', 'radius_meters'],
    additionalProperties: false,
  },
  execute: async ({ text, radius_meters }) => {
    const place = (await resolvePlace.execute({ text, max_results: 1 })) as { handle: string };
    const buffer = (await computeBuffer.execute({
      source: { kind: 'handle', id: place.handle },
      radius_meters,
    })) as { handle: string; area_sq_m: number };
    await render.execute({
      source: { kind: 'handle', id: buffer.handle },
      style: 'buffer',
      bucket: 'buffers',
      clear_first: true,
    });
    await viewZoomTo.execute({
      source: { kind: 'handle', id: buffer.handle },
      padding: 1.2,
    });
    return {
      place_handle: place.handle,
      buffer_handle: buffer.handle,
      area_sq_m: buffer.area_sq_m,
    };
  },
};
